import { useEffect } from "react";
import PropTypes from "prop-types";
import { STEP_TABS } from "./step-tabs";
import useScreenWorkshop from "./use-screen-workshop";
import WorkshopSampleRenderer from "./WorkshopSampleRenderer";
import WorkshopScreenView from "./WorkshopScreenView";

const SCREEN_TABS = [STEP_TABS.MAIN, STEP_TABS.FIELDS];

const ScreenWorkshop = ({
  tab,
  fieldsOpen,
  onFieldsOpen,
  share,
  ...screen
}) => {
  const workshop = useScreenWorkshop(screen);
  const { styleContent, variables, processId, report } = screen;
  const { select: selectField } = workshop.fields;
  useEffect(() => {
    if (!fieldsOpen) selectField(null);
  }, [fieldsOpen, selectField]);
  if (!SCREEN_TABS.includes(tab)) return null;
  const { sample, preview } = workshop;

  return (
    <>
      <WorkshopScreenView
        workshop={workshop}
        styleContent={styleContent}
        variables={variables}
        report={report}
        fieldsOpen={fieldsOpen}
        onFieldsOpen={onFieldsOpen}
        share={share}
      />
      {sample.on ? (
        <WorkshopSampleRenderer
          projectId={sample.projectId}
          processId={processId}
          htmlContent={preview.sourceHtml}
          styleContent={styleContent}
          slots={preview.slots}
          data={sample.data}
          refreshKey={sample.refreshKey}
          onRendered={sample.onRendered}
        />
      ) : null}
    </>
  );
};

ScreenWorkshop.propTypes = {
  tab: PropTypes.string,
  fieldsOpen: PropTypes.bool,
  onFieldsOpen: PropTypes.func,
  share: PropTypes.object,
  processId: PropTypes.string,
  title: PropTypes.string,
  screenVersionId: PropTypes.string,
  statusId: PropTypes.string,
  screenId: PropTypes.string,
  versionNumber: PropTypes.number,
  htmlContent: PropTypes.string,
  styleContent: PropTypes.string,
  slots: PropTypes.array,
  report: PropTypes.object,
  states: PropTypes.array,
  variables: PropTypes.array,
  formDefinition: PropTypes.object,
  liveFormDefinition: PropTypes.object,
  publishedScreen: PropTypes.shape({
    slots: PropTypes.array,
    states: PropTypes.array,
  }),
  published: PropTypes.bool,
  draftOnly: PropTypes.bool,
  onFormDefinitionChange: PropTypes.func,
  reload: PropTypes.func,
};

ScreenWorkshop.defaultProps = {
  tab: STEP_TABS.MAIN,
  fieldsOpen: false,
  onFieldsOpen: () => undefined,
  share: null,
  processId: undefined,
  title: undefined,
  screenVersionId: null,
  statusId: null,
  screenId: null,
  versionNumber: undefined,
  htmlContent: "",
  styleContent: undefined,
  slots: [],
  report: null,
  states: [],
  variables: [],
  formDefinition: null,
  liveFormDefinition: undefined,
  publishedScreen: null,
  published: false,
  draftOnly: false,
  onFormDefinitionChange: () => undefined,
  reload: undefined,
};

export default ScreenWorkshop;
